import { render, staticRenderFns } from "./MenuSkeleton.vue?vue&type=template&id=03a59cc9&scoped=true"
import script from "./MenuSkeleton.vue?vue&type=script&lang=js"
export * from "./MenuSkeleton.vue?vue&type=script&lang=js"
import style0 from "./MenuSkeleton.vue?vue&type=style&index=0&id=03a59cc9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a59cc9",
  null
  
)

export default component.exports